import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Message14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_153)'>
      <path
        d='M5 7C5 7.55228 4.55228 8 4 8C3.44772 8 3 7.55228 3 7C3 6.44772 3.44772 6 4 6C4.55228 6 5 6.44772 5 7Z'
        fill='currentColor'
      />
      <path
        d='M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44771 6 9 6.44772 9 7C9 7.55228 9.44771 8 10 8Z'
        fill='currentColor'
      />
      <path
        d='M8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.00004 13.75H6.99994C10.7279 13.75 13.75 10.7279 13.75 7C13.75 3.27208 10.7279 0.25 7 0.25C3.27208 0.25 0.25 3.27208 0.25 7C0.25 8.50307 0.742022 9.89257 1.57301 11.0144L0.404029 12.5447C0.0344181 13.0286 0.391153 13.75 1.00004 13.75ZM1.75 7C1.75 4.1005 4.1005 1.75 7 1.75C9.8995 1.75 12.25 4.1005 12.25 7C12.25 9.8995 9.89927 12.25 6.99977 12.25H2.51672L3.12379 11.4553C3.34235 11.1692 3.32676 10.7681 3.08664 10.4998C2.25487 9.57049 1.75 8.3451 1.75 7Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_153'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Message14.displayName = 'Message14';
export default Message14;
